export enum CheckoutPageKeys {
    Summary = "summary",
    CheckoutEntry = "checkout",
    CheckoutReturn = "checkout-return",
    CheckoutFinished = "thank-you",
}
